import type { API } from '@setplex/tria-api'

import { use as http } from './http'
import { use as logic } from './logic'

export function use(api: API) {
  http(api)
  logic(api)
}
